import * as React from "react"

const SvgComponent = (props) => (
  <svg
    viewBox="0 0 2250 2250"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
    }}
    {...props}
  >
    <circle
      cx={1125}
      cy={1125}
      r={1125}
      style={{
        fill: "#ea3546",
      }}
    />
    <path
      d="M1136.23 638.739v455.357M1264.25 1714.63h-258.143"
      style={{
        fill: "none",
        stroke: "#000",
        strokeWidth: "33.33px",
      }}
    />
    <circle cx={1136.23} cy={1054.54} r={84.032} />
    <path
      d="M996.727 1944.36v-546.079a340.465 340.465 0 0 0-89.621-230.203l-99.922-108.882 329.045-420.452 329.045 420.452-99.922 108.882a340.465 340.465 0 0 0-89.621 230.203v546.079H996.727Z"
      style={{
        fillOpacity: 0,
        stroke: "#000",
        strokeWidth: "33.33px",
      }}
      fill="none"
    />
    <path
      d="M1136.23 385.311h669.23"
      style={{
        fill: "none",
        stroke: "#000",
        strokeWidth: "33.33px",
      }}
    />
    <path
      d="M1136.23 385.311c177.49 0 347.711 70.507 473.216 196.012s196.012 295.726 196.012 473.216"
      style={{
        fill: "#ea3546",
        fillOpacity: 0,
        stroke: "#000",
        strokeWidth: "33.33px",
      }}
      fill="none"
    />
    <circle cx={1805.46} cy={1054.54} r={79.665} />
    <circle cx={1805.46} cy={385.311} r={79.665} />
    <path
      d="M1113.77 385.311H444.54"
      style={{
        fill: "none",
        stroke: "#000",
        strokeWidth: "33.33px",
      }}
    />
    <path
      d="M1113.77 385.311c-177.49 0-347.711 70.507-473.216 196.012s-196.012 295.726-196.012 473.216"
      style={{
        fill: "#ea3546",
        fillOpacity: 0,
        stroke: "#000",
        strokeWidth: "33.33px",
      }}
      fill="none"
    />
    <circle cx={444.541} cy={1054.54} r={79.665} />
    <circle cx={444.541} cy={385.311} r={79.665} />
    <circle cx={1136.23} cy={385.311} r={79.665} />
  </svg>
)

export default SvgComponent
